import { InfoPageItalicText } from './InfoPageItalicText.style';

export default InfoPageItalicText;
